(function () {
  'use strict';

  angular
    .module('compartilhamentos')
    .factory('Compartilhamentos', CompartilhamentosService);

  function CompartilhamentosService(Restangular) {
    return Restangular.service('auth/uo-compartilhamento');
  }
}());
